import { Injectable } from '@angular/core';
import { Response } from "@angular/http";
import { Observer } from "rxjs/Observer";
import { Observable } from "rxjs/Observable";

import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import "rxjs/Rx";
import { AuthHttp } from "angular2-jwt";
import { environment } from "../../../environments/environment";

@Injectable()
export class ColorResolver implements Resolve<Array<{ colorId: number, colorName: string }>> {
    constructor(private authHttp: AuthHttp) { }

    colors: Array<{ colorId: number, colorName: string }> = null;

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<{ colorId: number, colorName: string }>> | Promise<Array<{ colorId: number, colorName: string }>> | Array<{ colorId: number, colorName: string }> {
        return Observable.create((observer: Observer<Array<{ colorId: number, colorName: string }>>) => {
            if (this.colors != null) {
                observer.next(this.colors);
                observer.complete();
            } else {
                const qs = environment.apiPath + '/api/lookups/getColors?languageId=1';

                this.authHttp.get(qs)
                    .map(
                    (response: Response) => {
                        return response.json();
                    }).subscribe(
                    (response: any) => {
                        this.colors = response;
                        observer.next(response);
                        observer.complete();
                    },
                    (error: Error) => { });
            }
        });
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/lookups/color-resolver.service.ts